import { useAppSelector } from 'application/providers/StoreProvider';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountCompanyPricePlan = () => {
  const selectors = useAccountSelectors();

  return useAppSelector(selectors.selectCompanyPricePlan);
};
